export default "__VITE_ASSET__Ce0a1vmQ__"